import React, { Component } from 'react';
import axios from "axios";

import "../../../css/discounts-selector.css";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class DiscountCodeSelector extends Component{

    constructor(props){
        super(props);
        this.state = {
            itemSelected: {},
            isLoading: true,
            product: {},
            categoryProducts: [],
            quantity: 0
        }

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);

        if(this.state.categoryProducts.length <= 0 && this.props.discountCode && this.props.discountCode.get_item_type === "category"){
            this.loadDataCategory(this.props.discountCode.get_item_id);
        }
        else{
            if(this.props.discountCode){
                this.loadDataProduct(this.props.discountCode.get_item_type, this.props.discountCode.get_item_id);
            }
        }
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    loadDataCategory(id){
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }
        return axios.get(REACT_APP_API_URL + 'category-products/' + id, { headers: AUTH_HEADER })
        .then((response) => {
            console.log(response);
            this.setState({
                ...this.state,
                isLoading: false,
                categoryProducts: response.data.category_products
            })
        })
        .catch((err) => {
            console.log(err);
        })
    }
    loadDataProduct(type, id){

    }

    setWrapperRef(node) {
		this.wrapperRef = node;
    }

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.handleCloseSelector();
		}
	}

    render(){
        const { discountCode } = this.props;
        console.log(discountCode);
        console.log(this.state.categoryProducts);
        return (
            this.state.isLoading ? <div></div> : 
            <div className="dcs">
                <div className="dcs-box" ref={this.setWrapperRef}>
                    <div className="dcs-box-head">
                        <div>Apply Discount Code</div>
                        <div>{discountCode ? '[' + discountCode.code + ']' : ''}</div>
                    </div>
                    <div className="dcs-box-msg">
                        <div>Message goes here...</div>
                    </div>
                    <div className="dcs-box-body">
                        <div className="dcs-box-body-sub">
                            <div>Select from a {discountCode ? discountCode.get_item_type + ':' : ''}</div>
                        </div>
                        <div className="dcs-box-body-items">
                        { 
                        this.state.categoryProducts && this.state.categoryProducts.map((item, i) => 
                            <div key={i} className="dcs-box-body-items-item">
                                {item.title}
                                <button className="btn">Add</button>
                            </div>
                        )}
                        </div>
                    </div>
                    <div className="dcs-box-btns">
                        <button className="btn" onClick={this.props.handleApplyCoupon}>Apply</button>
                        <button className="btn" onClick={this.props.handleCloseSelector}>Cancel</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default DiscountCodeSelector;


// WEBPACK FOOTER //
// ./src/components/checkout/order-review/DiscountCodeSelector.js